import React from "react";
import Button from "@material-ui/core/Button";
import { LoadingContainerPadrao } from "./Base";
import { connect } from "react-redux";
import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";

function FullScreenDialog({ visible, saving, onCancel, onOk, children, title }) {
  return <Drawer
    closeIcon={<CloseOutlined style={{ fontSize: 20 }} />}
    destroyOnClose
    title={title}
    placement="bottom"
    height="100vh"
    onClose={onCancel}
    open={visible}
    headerStyle={{ padding: 10 }}
    extra={!!onOk && <Button style={{ margin: 0 }} color="inherit" onClick={onOk} disabled={saving}>
      {saving ? "Gravando" : "Gravar"}
    </Button>}>
    <LoadingContainerPadrao loading={saving}>
      <div>{children}</div>
    </LoadingContainerPadrao>
  </Drawer>;
}

export function DrawerPadrao({ visible, saving, onCancel, onOk, children, title, ...props }) {
  return <Drawer
    closeIcon={<CloseOutlined style={{ fontSize: 20 }} />}
    title={title}
    onClose={onCancel}
    open={visible}
    headerStyle={{ padding: 10 }}
    {...props}
  >
    <LoadingContainerPadrao loading={saving}>
      <div>{children}</div>
    </LoadingContainerPadrao>
  </Drawer>;
}


export default connect(null, {})(FullScreenDialog);